module.exports = __webpack_public_path__ + "static/google_play@2x-256380c8e255d42f178e8714ba9d1372.png";